import { PageMetaResolver } from '@spartacus/core'
import { Observable } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { CountryService } from '../../site-context/facade/country.service'
import {
  PageRobotsMeta,
  PageRobotsResolver,
  PageTitleResolver,
  TranslationService
} from '@spartacus/core'
import { PageType } from '@spartacus/core'
import { Injectable } from '@angular/core'
import { MbBasePageMetaResolver } from '../../cms/page/mb-base-page-meta-resolver'

@Injectable({
  providedIn: 'root',
})
export class MiltenyiPoUploadPageMetaResolver extends PageMetaResolver implements PageMetaResolver, PageTitleResolver, PageRobotsResolver {

  constructor (private translation: TranslationService,
               private countryService: CountryService,
               private mbBasePageMetaResolver: MbBasePageMetaResolver) {
    super()
    this.pageType = PageType.CONTENT_PAGE
    this.pageTemplate = 'PurchaseOrderUploadPageTemplate'
  }

  resolveTitle (): Observable<string> {
    return this.countryService.getActiveCountryNameInNatLang().pipe(
      switchMap((activeName: string) =>
        this.translation.translate('pageMetaResolver.poUpload.mbTitle', { countryName: activeName })
      )
    )
  }

  resolveRobots (): Observable<PageRobotsMeta[] | undefined> {
    return this.mbBasePageMetaResolver.resolveRobots()
  }
}
